// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"TenantMatching_pageWrapper__2ZbGZ","headerWrapper":"TenantMatching_headerWrapper__uj7vn","column":"TenantMatching_column__39YKq"};